import React, { Fragment, useContext } from "react";
import Expander from "../Expander";
import Link from "../Link";
import SelectedTestsContext from "./contexts/SelectedTestsContext";
import { useTests } from "./contexts/ResultsContext";
import SampleColumns from "./SampleColumns";
import { CenterTd } from "./theme/Theme";

export default function GroupedSampleTests({
  sample,
  sample_tests,
  showSample,
  collapseTechnique,
  selectedSampleTestIds,
  clientView = true,
  viewSingleSample,
  simpleSampleView
}) {
  const {
    dispatch,
    state: { selectedSampleIds }
  } = useContext(SelectedTestsContext);
  const tests = useTests();
  const sampleTestIds = sample_tests.map(st => st.id);
  const checked =
    selectedSampleTestIds.filter(id => sampleTestIds.includes(id)).length /
      sample_tests.length >
    0.5;

  function handleToggle() {
    dispatch({
      type: "toggleForSample",
      select: !checked,
      sampleId: sample.sample.identifier,
      sampleTestIds: sample_tests.map(st => st.id)
    });
  }

  function handleSelectSample(e) {
    dispatch({
      type: "selectSample",
      selected: e.target.checked,
      sampleId: sample.sample.identifier
    });
  }

  const techniqueName = tests[sample_tests[0].test_id].technique_name;
  const isSampleSelected = selectedSampleIds.includes(sample.sample.identifier);
  return (
    <tr>
      <SampleColumns
        sample={sample}
        showSample={showSample}
        clientView={clientView}
        handleSelectSample={handleSelectSample}
        isSampleSelected={isSampleSelected}
        viewSingleSample={viewSingleSample}
        simpleSampleView={simpleSampleView}
      />
      <td>
        <Link onClick={collapseTechnique}>
          <Expander expanded={false} />
          {techniqueName}
        </Link>
      </td>
      <td colSpan="2">
        <b>{sample_tests.length} Tests</b>
      </td>
      <td colSpan="6" />
      {!clientView && (
        <CenterTd>
          <input type="checkbox" onChange={handleToggle} checked={checked} />
        </CenterTd>
      )}
    </tr>
  );
}
